<template>
    <div class="flex items-center align-center justify-center w-full">
        <h2 class="text-center text-3xl">Processing Microsoft Authentication, Please Wait...</h2>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "MicrosoftOAth",
        methods: {
            handleCallback: function(){
                const params = new URLSearchParams(window.location.search);
                let code = params.get('code');

                axios.post(process.env.VUE_APP_API_URL + '/auth/microsoft/callback', {
                    code: code
                }).then(response => {
                    if (response.data.success){
                        this.$router.push('/dashboard');
                    }
                }).catch(error => {

                })
            }
        },
        beforeMount() {
            this.handleCallback();
        }
    }
</script>

<style scoped>

</style>
